import React from 'react';

// Icons are block-level under Tailwind's preflight, so the base layout must be a
// flex row — otherwise a trailing icon wraps onto its own line.
export function Button({ children, className = '', ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
